import $ from "jquery";
import { i18n } from "../../common/translations";
import {GAEvent} from "../../common/google_analytics/google_analytics";
import { constants } from "../../common/constants/constants";
import {BllinkLogger} from "../../common/utils/bllink_loggers";
require('jquery-validation');

export default class NewBuildingLogic{

    static validateCreateForm(validator, thisObj){

        BllinkLogger.info(`validateCreateForm create building validator `, validator);
        if (validator){
            BllinkLogger.info('destroy validation')
            BllinkLogger.info(validator.destroy());
        }

        let results = this.buildingRules(thisObj.state.managerRows);

        // Initialize form validation on the registration form.
        // It has the name attribute "registration"
        validator = $("form[id='js-new-building']").submit(function(e) {
            e.preventDefault();
        }).validate({
                // Specify validation rules
                rules: results.rules,
                // Specify validation error messages
                messages: results.messages,

                // Make sure the form is submitted to the destination defined
                // in the "action" attribute of the form when valid
                submitHandler: async function(form) {
                    thisObj.submitCreateBuildingForm();
                    return false
                },

                invalidHandler: function(form, validator) {
                    for (const error of validator.errorList){
                        GAEvent(constants.GoogleAnalytics.Events.createBuilding, 'validationError', 1, $(error.element).attr('name'));
                    }
                }
            });

        return validator
    }


    static buildingRules(managerRows){
        let rules = {search: "required"};
        let messages = {search: i18n.t('titles.forms.mandatory_field')};

        [...Array(managerRows).keys()].forEach((value, index) => {
            BllinkLogger.info(`adding rule for building-manager-${index}`)
            rules[`building-manager-${index}`] = "required";
            messages[`building-manager-${index}`] = i18n.t('titles.forms.mandatory_field');
        })

        return {
            rules: rules,
            messages: messages
        }


    }
}
